import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel, {
  ValueChangedEvent,
} from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global, useMenuStore } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import { fnSave } from "@shared/api/restApi";
import SnButton from "@shared/components/SnButton";
import SnResizeBar from "@shared/components/SnResizeBar";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { useNavigate } from "react-router-dom";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_QMS_REQ_REP_003 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const { menuItems } = useMenuStore();

  const searchRef = useRef<any>(null);
  const formControlDataRef = useRef<any[]>([]);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchForm();
  }, []);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_qms_req_rep_003_01",
        params: searchRef.current.getFormdata(),
      };
      gridRefs.current["grid1"].current.resetUpdate();
      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: data[0],
      });
    } catch (error: any) {}
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1">
        <SnGrid
          ref={gridRefs.current["grid1"]}
          columnConfig={grids.grid1.columns}
          rowData={grids.grid1.dataSource}
          etcProps={{
            isEditable: true,
            rowSelection: "multiple",
            title: "내역정보",
          }}
        />
      </div>
    </div>
  );
});

export default SN_QMS_REQ_REP_003;
